function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_33033_7107)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.6014 7.72859H25.3592V6.39359H26.6956V4.63578H25.3592V3.30078H23.6014V4.63578H22.2649V6.39359H23.6014V7.72859Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.997 5.43135C29.9521 2.42883 27.4949 0 24.4803 0C23.2182 0 22.054 0.425977 21.1233 1.14123H-0.00195312V30H29.998V5.43135H29.997ZM24.4803 1.75781C26.5535 1.75781 28.2402 3.4432 28.2402 5.51479C28.2402 7.58637 26.5535 9.27182 24.4803 9.27182C22.407 9.27182 20.7203 7.58643 20.7203 5.51479C20.7203 3.44314 22.407 1.75781 24.4803 1.75781ZM1.75586 2.89904H19.6237C19.3354 3.4316 19.1325 4.01672 19.0329 4.63588H3.91885V6.39369H19.0329C19.1325 7.01291 19.3354 7.59797 19.6237 8.13059H1.75586V2.89904ZM8.31432 22.5904V28.2422H5.27834V15.1808H8.31426V20.8326H7.20397V22.5904H8.31432ZM10.0721 28.2422V22.5904H11.1825V20.8326H10.0721V15.1808H13.1081V28.2422H10.0721ZM18.3815 20.9581V15.1809H22.432V20.9581H18.3815ZM24.1898 15.1808H28.2402V20.958H24.1898V15.1808ZM16.6237 13.423V22.7159H28.2402V28.2422H14.8659V13.423H3.52053V28.2422H1.75586V9.8884H21.1233C22.054 10.6037 23.2182 11.0296 24.4803 11.0296C25.9319 11.0296 27.2541 10.4662 28.2402 9.54703V13.4231H16.6237V13.423Z",
  fill: "#23335B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_33033_7107"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white",
  transform: "translate(-0.00195312)"
})));

var SvgManageOrganisation = function SvgManageOrganisation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManageOrganisation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manage_organisation.303c3ce3.svg";
export { ForwardRef as ReactComponent };